import React from 'react';

const TextImageBlock = ({ data }) => {
  return (
    <section className={`text-image ${data.layout}`}>
      <div className="container">
        <div className="text-image-content">
          <div className="text-content">
            <h2>{data.title}</h2>
            <p>{data.text}</p>
          </div>
          <div className="image-content">
            <img src={data.image.src} alt={data.image.alt} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextImageBlock; 